export default __webpack_public_path__ + "static/logo-white-7a0bea3ba39b7c3770bf3a8aa59f24d8.svg";